export enum ProductType {
  Physical = "Physical",
  Digital = "Digital",
}
